
import {IGatsbyImageData} from 'gatsby-plugin-image';

export interface GraphQLImage {
	localFiles: {
		childImageSharp: {
			gatsbyImageData: IGatsbyImageData
		}
	}[]
}

export enum ImageUse {
	primary = 'Primary',
	content = 'Content',
	thumbnail = 'Thumbnail'
}

export const getImage = (field: GraphQLImage): IGatsbyImageData => {
	return field.localFiles?.[0].childImageSharp.gatsbyImageData;
};
